import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import LandingPage from 'modules/LandingPage'
import { showLogin } from 'modules/UI/actions'
import { AuthPopupEnum } from 'utils/constants'

const SignupPage = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)

  useEffect(() => {
    if (!user.isFetching && !user.details) dispatch(showLogin(AuthPopupEnum.register))
  }, [dispatch, user.isFetching, user.details])

  if (user.details) return <Navigate to="/" replace />
  return <LandingPage />
}

export default SignupPage
